import { axiosClient } from '@/libs/axios-client';

/**
 * An employee's contract history: employment contracts and annexes, oldest
 * first. Entries are typed by hand or recorded when a contract/annex document
 * is created from a template.
 */
export const listEmploymentContracts = async (employeeId) => {
  const response = await axiosClient.get('/employment-contracts', {
    params: { employee: employeeId },
  });
  return response.data;
};

export const createEmploymentContract = async (payload) => {
  const response = await axiosClient.post('/employment-contracts', payload);
  return response.data;
};

export const updateEmploymentContract = async (id, payload) => {
  const response = await axiosClient.put(`/employment-contracts/${id}`, payload);
  return response.data;
};

export const deleteEmploymentContract = async (id) => {
  const response = await axiosClient.delete(`/employment-contracts/${id}`);
  return response.data;
};
